import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BcLicenseSummary,
  BcLicenseSummaryResponse,
  CspSubscription,
  CspSubscriptionResponse,
  CspSubscriptionsQueryParams,
} from '@models/csp/subscription.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class CspSubscriptionsService {
  private readonly url = `${environment.bffUrl}/csp/subscriptions`;
  constructor(private httpClient: HttpClient) {}

  getAll(params: CspSubscriptionsQueryParams): Observable<CspSubscription[]> {
    return this.httpClient.get<CspSubscriptionResponse[]>(this.url, { params });
  }
  getBcLicenseSummary(customerTenantId: string): Observable<BcLicenseSummary[]> {
    return this.httpClient.get<BcLicenseSummaryResponse[]>(`${this.url}/${customerTenantId}/bc-license-summary`);
  }
}
